'use client';

import { Card, CardContent, CardFooter } from '@/components/ui/card';
import { SocialLogin } from '@/app/(founder)/auth/_components/social-login';
import LogoIcon from '@/assets/logo.svg';
import { ReactNode } from 'react';

type Props = {
    children: ReactNode;
    footer?: ReactNode;
    socialLogin?: boolean;
};

export function AuthFormWrapper({
    children,
    footer,
    socialLogin = true,
}: Props) {
    return (
        <Card className="w-full max-w-md bg-neutral-850 border-neutral-650">
            <CardContent>
                <div className="flex justify-center w-full py-12">
                    <LogoIcon width={58} height={64} />
                </div>
                {socialLogin && (
                    <>
                        <SocialLogin />
                        <div className="relative flex justify-center text-sm">
                            <span className="py-6 text-muted-foreground">
                                or
                            </span>
                        </div>
                    </>
                )}
                {children}
            </CardContent>
            {footer && (
                <CardFooter className="flex justify-center">
                    {footer}
                </CardFooter>
            )}
        </Card>
    );
}
